import React from 'react';

const Placeholder: React.FC<{}> = () => {
    return <div>No midi inputs found</div>;
};

export default Placeholder;
